import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';
import classnames from 'classnames';
import { useDisabled } from '@hh.ru/magritte-common-use-disabled';
import { C as CheckboxSkeleton, s as styles } from './CheckboxSkeleton-DuHjgFjX.js';
import { CheckboxLineSize24, CheckboxCheckSize24 } from '@hh.ru/magritte-ui-icon/variants/private';
import { enrichWithSkeleton } from '@hh.ru/magritte-ui-skeleton';
import '@hh.ru/magritte-common-use-loading-state';

const CheckboxComponent = ({ checked, disabled, invalid, indeterminate = false, onChange, readOnly, 'aria-label': ariaLabel, 'data-qa': dataQaInput, dataQaContainer = 'checkbox-container', dataQaCheckbox = 'checkbox', ...props }) => {
    const forceDisabled = useDisabled();
    const checkboxRef = useRef(null);
    useEffect(() => {
        if (!checkboxRef.current) {
            return;
        }
        checkboxRef.current.indeterminate = indeterminate;
    }, [indeterminate]);
    return (jsxs("span", { className: styles.checkboxContainer, "data-qa": dataQaContainer, children: [jsx("input", { ...props, checked: checked, "data-qa": dataQaInput, 
                // Checkable Card вызывает event.preventDefault(),
                // из-за чего браузер не перерисовывает чекбокс при изменении пропа checked,
                // поэтому в controlled чекбоксах полагаемся на CSS-класс, а не на селектор :checked
                className: classnames(styles.checkboxInput, {
                    [styles.checkboxInputChecked]: checked,
                    // нужно отличать false от undefined, потому что в случае uncontrolled чекбокса
                    // checked равен undefined и значение задается через проп defaultChecked
                    [styles.checkboxInputUnchecked]: Object.is(checked, false),
                }), ref: checkboxRef, readOnly: readOnly, type: "checkbox", "aria-label": ariaLabel, disabled: forceDisabled || !!disabled, onChange: onChange }), jsx("span", { className: classnames(styles.checkbox, {
                    [styles.invalid]: invalid,
                }), "data-qa": dataQaCheckbox }), jsxs("span", { className: styles.iconWrapper, children: [jsx("span", { className: classnames(styles.icon, {
                            [styles.iconHidden]: !indeterminate,
                        }), children: jsx(CheckboxLineSize24, {}) }), jsx("span", { className: classnames(styles.icon, {
                            [styles.iconHidden]: indeterminate,
                        }), children: jsx(CheckboxCheckSize24, {}) })] })] }));
};
CheckboxComponent.isCheckbox = true;
const Checkbox = enrichWithSkeleton(CheckboxComponent, CheckboxSkeleton);

export { Checkbox };
//# sourceMappingURL=Checkbox.js.map
